module.exports = __webpack_public_path__ + "img/重庆迎风湖国家湿地公园@2x.3a6b3360.png";